var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutgoingVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video-outgoing",
    d: "m14 5h-9a2.652 2.652 0 0 0 -3 3v8a2.652 2.652 0 0 0 3 3h9a2.652 2.652 0 0 0 3-3v-8a2.652 2.652 0 0 0 -3-3zm-1.25 7.5a.75.75 0 0 1 -1.5 0v-1.189l-3.72 3.719a.75.75 0 0 1 -1.06-1.06l3.719-3.72h-1.189a.75.75 0 0 1 0-1.5h3a.753.753 0 0 1 .75.75zm9.25-4.94v8.88a.753.753 0 0 1 -1.224.587l-2.164-1.737a.3.3 0 0 1 -.112-.234v-6.112a.3.3 0 0 1 .112-.234l2.164-1.737a.753.753 0 0 1 1.224.587z",
    fill: "rgb(0,0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoingVideo);
export default __webpack_public_path__ + "static/media/Outgoing_Video.74cfa705897322762a163847a356fa06.svg";
export { ForwardRef as ReactComponent };